<div class="srp-language-search">
  <mat-form-field [appearance]="appearance" [ngClass]="variant ? 'variant-' + variant : ''">
    @if(defaultlabel && variant !== 'search') {
      <mat-label>{{defaultlabel}}</mat-label>
    }
    <mat-select [disabled]="disabledSignal()" [value]="value()" (selectionChange)="onChangeHandler($event.value)"
      (blur)="onBlur()" (openedChange)="isPanelOpen.set($event)">
      <mat-select-trigger>
        @if(getSelectedOption(); as selected) {
          @if(selected.image) {
            <srp-icon [icon]="selected.image"></srp-icon>
          }
          {{ getDisplay(selected) }}
        }
      </mat-select-trigger>
      <mat-form-field [appearance]="appearance" class="custom-input-search">
        <input matInput (keyup)="onKey($event.target)" [placeholder]="defaultlabel" />
      </mat-form-field>
      @if(options.length > 0) {
        <ng-container>
          @for (item of localOptions(); track $index) {
            <mat-option [value]="getValue(item)">
              @if(isPanelOpen() && item.image) {
                <srp-icon [icon]="item.image"></srp-icon>
              }
              {{ getDisplay(item) }}
            </mat-option>
          }
        </ng-container>
      } @else {
        <ng-template #noOption>
          <mat-option>No Options</mat-option>
        </ng-template>
      }
    </mat-select>
    @if (control?.invalid && control?.touched) {
      <mat-error>
        {{ getErrorMessage() }}
      </mat-error>
    }
  </mat-form-field>
</div>